{
  "greeting": {
    "salam": "السلام عليكم",
    "salamWithName": "السلام عليكم، {{name}}"
  },
  "dock": {
    "saved": "المحفوظات",
    "savedVerses": "الآيات المحفوظة",
    "tasks": "المهام",
    "notes": "الملاحظات"
  },
  "actions": {
    "save": "حفظ",
    "cancel": "إلغاء",
    "close": "إغلاق",
    "delete": "حذف",
    "rename": "إعادة تسمية",
    "dismiss": "تجاهل",
    "loading": "جارٍ التحميل…",
    "reload": "إعادة التحميل",
    "retry": "إعادة المحاولة",
    "expand": "توسيع",
    "collapse": "طي"
  },
  "nav": {
    "appNavigation_aria": "التنقل في التطبيق"
  },
  "tabs": {
    "home": "الرئيسية",
    "tasks": "المهام",
    "notes": "الملاحظات",
    "more": "المزيد"
  },
  "more": {
    "daily": "اليومي",
    "account": "الحساب",
    "savedVerses": "الآيات المحفوظة",
    "qibla": "القبلة",
    "prayerTimes": "أوقات الصلاة والتذكيرات",
    "rhemnPro": "Rhemn Pro",
    "proManagedViaAccount": "تتم إدارته عبر حسابك في Rhemn",
    "upgrade": "ترقية",
    "privacyPolicy": "سياسة الخصوصية",
    "version": "Rhemn · v{{version}}",
    "back_aria": "رجوع",
    "deleteAccount": "حذف الحساب"
  },
  "reflection": {
    "dismiss_aria": "تجاهل التأمل"
  },
  "app": {
    "loading_aria": "جارٍ تحميل Rhemn",
    "logo_alt": "Rhemn",
    "safariManageOnWeb": "أدِر اشتراكك في Rhemn Pro عبر الويب. تُفتَح ميزات Pro تلقائيًا هنا عند تسجيل الدخول بحسابك المشترك."
  },
  "header": {
    "qiblaDirection_aria": "اتجاه القبلة",
    "prayerTimes_aria": "مواقيت الصلاة",
    "prayerTimesTitle": "مواقيت الصلاة",
    "method": "طريقة الحساب",
    "methodHelp": "تؤثّر طريقة الحساب في المواقيت المحسوبة"
  },
  "search": {
    "search_aria": "بحث",
    "searchLabel": "بحث",
    "searchWeb_placeholder": "ابحث في الويب"
  },
  "focus": {
    "input_placeholder": "ما الأهم اليوم؟",
    "example_worship": "أصلّي بخشوع لا على عجل",
    "example_kindness": "أتّصل بأمي فقط لأستمع إليها",
    "example_reflect": "تأمّل نيّتك مع آية اليوم",
    "saveIntention_aria": "حفظ النيّة",
    "celebration": "🤲 ما شاء الله"
  },
  "profile": {
    "profileFallback": "الملف الشخصي",
    "profileAndAccount_aria": "الملف الشخصي والحساب",
    "profileDialog_aria": "الملف الشخصي",
    "editName_aria": "تعديل اسمك",
    "logo_alt": "Rehmn",
    "proBadge": "PRO",
    "manageSubscription": "إدارة الاشتراك",
    "manageSubscription_aria": "أدِر اشتراكك في Rehmn Pro",
    "anonymousAnalytics": "تحليلات مجهولة الهوية",
    "anonymousAnalyticsNote": "إجمالية فقط — لا تُربط بك أبدًا",
    "shareAnalytics_aria": "مشاركة تحليلات الاستخدام مجهولة الهوية",
    "signOut": "تسجيل الخروج",
    "signingOut": "جارٍ تسجيل الخروج…",
    "signOut_aria": "تسجيل الخروج من Rehmn",
    "restorePurchases": "استعادة المشتريات",
    "restorePurchases_aria": "استعادة المشتريات السابقة"
  },
  "background": {
    "loading": "جارٍ تحميل الخلفية...",
    "fallbackNotice": "تُستخدم صورة احتياطية (واجهة Unsplash غير متاحة)",
    "noImage": "لا توجد صورة خلفية متاحة",
    "error": "خطأ: {{message}}",
    "photoByOnUnsplash": "صورة بعدسة <photographer>{{name}}</photographer> على <unsplash>Unsplash</unsplash>"
  },
  "error": {
    "title": "حدث خطأ ما",
    "fallbackMessage": "حدث خطأ غير متوقع."
  },
  "theme": {
    "switchToLight_title": "التبديل إلى الوضع الفاتح",
    "switchToDark_title": "التبديل إلى الوضع الداكن"
  },
  "upgradeCta": {
    "upgradeToPro": "الترقية إلى Pro",
    "restorePurchases": "استعادة المشتريات",
    "restoring": "جارٍ الاستعادة…",
    "restoreEmpty": "لم يتم العثور على مشتريات.",
    "pricePerMonth": "{{price}} / شهرياً",
    "pricePerYear": "{{price}} / سنوياً",
    "purchasePending": "في انتظار الموافقة. سيتم تفعيل Pro تلقائياً بمجرد الموافقة على عملية الشراء.",
    "storeUnavailable": "تعذّر الوصول إلى App Store حالياً. حاول مرة أخرى بعد قليل.",
    "purchaseFailed": "تعذّر إتمام عملية الشراء. حاول مرة أخرى بعد قليل."
  },
  "upgradeCard": {
    "eyebrow": "Rhemn Pro · خصم 25% على سنتك الأولى",
    "title": "للساعات التي بين صلواتك.",
    "body": "ملاحظات صوتية تُفرَّغ وتُلخَّص وتتحوّل إلى مهام. مخطِّط يومي مبني حول مواقيت صلاتك. ملاحظات بالذكاء الاصطناعي.",
    "price": "$29.99",
    "period": "لسنتك الأولى",
    "priceIos": "خصم 25% على سنتك الأولى",
    "terms": "ثم $39.99 سنويًا. تم تطبيق الرمز {{code}} لك.",
    "termsIos": "يتجدد بالسعر السنوي المعتاد. استخدم الرمز {{code}} في App Store.",
    "free": "مواقيت الصلاة والقبلة وآية اليوم والمهام تبقى مجانية.",
    "cta": "الترقية إلى Pro",
    "dismiss": "ليس الآن"
  },
  "planChooser": {
    "monthly": "شهري",
    "yearly": "سنوي",
    "yearlyValue": "أربعة أشهر هدية منا.",
    "freeNote": "مواقيت الصلاة والقبلة وآية اليوم والمهام مجانية. يضيف Rhemn Pro:",
    "includes_planner": "خطة يوم مبنية حول الصلوات الخمس، و«خطّط يومي»",
    "includes_insights": "رؤى القرآن — اسأل عن أي آية واقرأ سياقها",
    "includes_reflections": "تأملات في آية اليوم مكتوبة حسب النية التي حدّدتها",
    "includes_notes": "ملاحظات وملاحظات صوتية مع تنقيح وتلخيص بالذكاء الاصطناعي",
    "includes_extras": "الآيات المحفوظة، وبطاقات الآيات، والسلاسل، وتوقعات 5 أيام",
    "renewsMonthly": "يتجدد كل شهر حتى الإلغاء",
    "renewsYearly": "يتجدد كل 12 شهرًا حتى الإلغاء",
    "continue": "متابعة",
    "renewalTerms": "يُخصم المبلغ من حساب Apple ID عند تأكيد الشراء. يتجدد الاشتراك تلقائيًا ما لم يتم إيقاف التجديد التلقائي قبل 24 ساعة على الأقل من نهاية الفترة. يمكنك الإدارة أو الإلغاء في أي وقت من إعدادات Apple ID.",
    "retry": "حاول مجددًا"
  },
  "streak": {
    "badge_aria": "المواظبة اليومية — {{count}} يومًا",
    "title": "المواظبة اليومية",
    "daysWithCount": "مواظبة {{count}} يومًا",
    "start": "ابدأ اليوم — اقضِ لحظة مع الآية أو سجّل صلاة.",
    "prayedToday": "صلّيت اليوم",
    "readVerse": "قرأت آية اليوم",
    "autoHint": "تُسجَّل الآية تلقائيًا عندما تقضي لحظة معها.",
    "milestoneTitle": "{{count}} يومًا من النية",
    "milestoneBody": "الحمد لله. شارك هذا الإنجاز — فقد يبدأ من تحب أيضًا.",
    "share": "مشاركة",
    "dismiss": "ليس الآن",
    "cardLabel": "يومًا من النية",
    "shareCaption": "{{count}} يومًا من البدء بنيّة — rhemn.com",
    "imageSaved": "تم حفظ الصورة.",
    "couldNotCreateImage": "تعذّر إنشاء الصورة. يُرجى المحاولة مرة أخرى."
  },
  "qibla": {
    "compassIcon_aria": "أيقونة البوصلة",
    "title": "اتجاه القبلة",
    "locationUnavailable": "الموقع غير متاح",
    "locating": "جارٍ تحديد الموقع…",
    "compass_aria": "بوصلة القبلة",
    "directionN": "ش",
    "directionE": "شر",
    "directionS": "ج",
    "directionW": "غ",
    "facingQibla": "أنت تواجه القبلة",
    "enableLiveCompass": "تفعيل البوصلة الحيّة",
    "enableLiveCompassNote": "تستخدم مستشعر الحركة ليتبع السهم اتجاهك عند الدوران — وليس الموقع",
    "directionToMecca": "الاتجاه نحو مكة",
    "enableLocation": "فعّل الوصول إلى الموقع لحساب الاتجاه",
    "hintLive": "يتتبّع السهم اتجاه جهازك في الوقت الفعلي",
    "hintStatic": "الاتجاه من الشمال — استخدمه مع بوصلة لتحديد دقيق",
    "live": "حيّ",
    "footerVerse": "\"فَوَلِّ وَجْهَكَ شَطْرَ الْمَسْجِدِ الْحَرَامِ\" – القرآن 2:144"
  },
  "legal": {
    "links_aria": "قانوني",
    "termsOfUse": "شروط الاستخدام",
    "privacyPolicy": "سياسة الخصوصية"
  },
  "auth": {
    "signInForPro": "سجّل الدخول أولًا — يذهب Pro معك أينما كنت."
  },
  "integrations": {
    "row": {
      "label": "التقويمات والمهام",
      "caption": "متصل",
      "subNone": "غير متصل",
      "subFree": "تقويم Google وGoogle Tasks والمزيد",
      "subAttention": "{{provider}} يحتاج إلى انتباه",
      "subPaused": "المزامنة متوقفة مؤقتًا"
    },
    "list": {
      "title": "التقويمات والمهام",
      "subtitle": "أحضر اجتماعاتك ومهامك إلى يومك.",
      "footnote": "يقرأ Rhemn فقط ما يحتاجه، ولا يخزّن أحداثك أبدًا.",
      "privacy": "سياسة الخصوصية",
      "connect": "ربط",
      "connect_aria": "ربط {{what}}",
      "checking": "جارٍ التحقق…",
      "loadError": "تعذّر تحميل اتصالاتك.",
      "tryAgain": "حاول مجددًا",
      "offline": "أنت غير متصل بالإنترنت. اربط عند عودة الاتصال.",
      "unavailable": "التقويمات والمهام غير متاحة حاليًا.",
      "disconnected": "تم قطع اتصال {{provider}}.",
      "google": {
        "name": "Google",
        "sub": "التقويم والمهام",
        "what": "تقويم Google والمهام"
      },
      "todoist": {
        "name": "Todoist",
        "sub": "المهام والمشاريع",
        "what": "Todoist"
      },
      "apple": {
        "name": "التقويم والتذكيرات",
        "subNative": "على هذا {{device}}",
        "subSafari": "في تطبيق Rhemn لأجهزة iPhone وMac"
      },
      "synced": "تمت المزامنة {{when}}",
      "connectedSub": "متصل",
      "syncing": "جارٍ المزامنة…",
      "reconnectSub": "أعد الاتصال لمتابعة المزامنة",
      "errorSub": "لم تكتمل آخر مزامنة",
      "pausedSub": "متوقف مؤقتًا · انتهى اشتراك Rhemn Pro"
    },
    "explainer": {
      "google": {
        "title": "ربط تقويم Google والمهام",
        "p1Lead": "تقويمك، للقراءة فقط",
        "p1Body": "يعرض Rhemn أحداثك ضمن يومك ويرى متى تكون مشغولًا. لا يقوم بتخزينها.",
        "p2Lead": "مهام Google، في الاتجاهين",
        "p2Body": "تبقى القوائم التي تختارها متزامنة، لتتمكن من إنهاء المهام من أي مكان.",
        "p3Lead": "يمكنك التراجع",
        "p3Body": "اقطع الاتصال في أي وقت، من هنا أو من حساب Google الخاص بك.",
        "footnote": "سيوضح لك Google بالضبط ما يطلبه Rhemn."
      },
      "todoist": {
        "title": "ربط Todoist",
        "p1Lead": "مشاريعك، في الاتجاهين",
        "p1Body": "تبقى المشاريع التي تختارها متزامنة، لتتمكن من إنهاء المهام من أي مكان.",
        "p2Lead": "كيف تتم المطابقة",
        "p2Body": "تتحول أولويات Todoist إلى حرجة وعالية ومتوسطة ومنخفضة. تظهر المهام الفرعية الأعمق من مستوى واحد كخطوات تحت مهمتها الرئيسية.",
        "p3Lead": "يمكنك التراجع",
        "p3Body": "اقطع الاتصال في أي وقت، من هنا أو من إعدادات Todoist.",
        "cta": "المتابعة إلى Todoist",
        "footnote": "سيطلب منك Todoist التأكيد."
      },
      "skip": "ليس الآن",
      "cancel": "إلغاء",
      "waiting": "بانتظار {{provider}}…",
      "safariWaiting": "أكمل في التبويب الجديد، ثم عد إلى هنا.",
      "safariReopen": "فتح التبويب مجددًا",
      "denied": "لم يمنح {{provider}} الإذن، لذا لم يتم ربط أي شيء.",
      "error": "تعذّر الاتصال بـ{{provider}}. حاول مجددًا بعد لحظات."
    },
    "detail": {
      "back_aria": "العودة إلى التقويمات والمهام",
      "syncNow": "مزامنة الآن",
      "intro": "اختر ما يزامنه Rhemn. يمكنك تغيير هذا في أي وقت.",
      "taskLists": "قوائم المهام",
      "projects": "المشاريع",
      "reminders": "التذكيرات",
      "calendars": "التقويمات",
      "rhemnCalendarSub": "أوقات صلاتك، لا تُحتسب كوقت مشغول",
      "loading": "جارٍ التحميل…",
      "loadError": "تعذّر تحميل قوائمك.",
      "emptyGoogle": "لا توجد قوائم مهام في Google Tasks.",
      "emptyTodoist": "لا توجد مشاريع في Todoist.",
      "addError": "تعذّر إضافة {{name}}. حاول مجددًا.",
      "removed": "تمت الإزالة من Rhemn. ما زالت موجودة في {{provider}}.",
      "undo": "تراجع",
      "prayerTimes": "أضف أوقات الصلاة إلى تقويمك",
      "prayerTimesSub": "يضيف الصلوات الخمس إلى تقويم باسم Rhemn، للأيام السبعة القادمة، حتى لا يحجز أحد عليها.",
      "prayerTimesOn": "مفعّل. أُضيفت حتى {{date}}.",
      "prayerTimesWaiting": "بانتظار Google…",
      "prayerTimesDenied": "لم يسمح Google بذلك. لم تتم إضافة شيء.",
      "prayerTimesRemoveAsk": "إزالة أوقات صلاة Rhemn من تقويمك؟",
      "prayerTimesKeep": "الإبقاء عليها",
      "prayerTimesRemove": "إزالة",
      "meetingPrompts": "تنبيهات الاجتماعات",
      "meetingPromptsSub": "عندما يكون اجتماع برابط على وشك البدء، يُعرض عليك تدوين ملاحظات.",
      "busyFootnote": "تطّلع ميزة «خطّط يومي» فقط على أوقات انشغالك، لا على محتوى اجتماعاتك.",
      "todoistFootnote": "تتحول أولويات Todoist إلى حرجة وعالية ومتوسطة ومنخفضة. تظهر المهام الفرعية الأعمق من مستوى واحد كخطوات تحت مهمتها الرئيسية.",
      "reauth": "توقف {{provider}} عن السماح لـRhemn بالمزامنة. يحدث هذا عند إلغاء الإذن أو تغيير كلمة مرورك.",
      "reconnect": "إعادة الاتصال",
      "paused": "المزامنة متوقفة لأن اشتراك Rhemn Pro انتهى. تبقى قوائمك كما كانت.",
      "calendarDenied": "الوصول إلى التقويم معطّل.",
      "remindersDenied": "الوصول إلى التذكيرات معطّل.",
      "disconnect": "قطع اتصال {{provider}}",
      "disconnectTitle": "قطع اتصال {{provider}}؟",
      "disconnectBody": "لن يُحذف أي شيء في {{provider}}.",
      "disconnectRhemnCal": "ستتم إزالة تقويم أوقات صلاة Rhemn من تقويم Google.",
      "disconnectError": "تعذّر قطع اتصال {{provider}}. حاول مجددًا بعد لحظات.",
      "keepLists": "الإبقاء على قوائمي في Rhemn",
      "keepListsSub": "تتوقف عن المزامنة وتصبح قوائم عادية في Rhemn.",
      "removeLists": "إزالتها من Rhemn",
      "removeListsSub": "تُزال فقط النسخ الموجودة في Rhemn.",
      "disconnecting": "جارٍ قطع الاتصال…",
      "appleStop": "التوقف عن استخدام التقويم والتذكيرات",
      "appleStopTitle": "التوقف عن استخدام التقويم والتذكيرات؟",
      "appleStopBody": "سيتوقف Rhemn عن عرض أحداثك وتذكيراتك. لإزالة وصوله بالكامل، أوقفه من الإعدادات.",
      "justNow": "منذ لحظات",
      "tasksScope": "يحتاج Rhemn إلى إذن لرؤية Google Tasks الخاصة بك. أعد الاتصال وفعّل خيار المهام للسماح بذلك.",
      "calendarsLoadError": "تعذّر تحميل تقويماتك.",
      "calendarsEmpty": "لا توجد تقويمات في هذا الحساب.",
      "calendarsScope": "يحتاج Rhemn إلى إذن لرؤية تقويم Google. أعد الاتصال وحدّد التقويم للسماح بذلك.",
      "prayerTimesError": "تعذّرت إضافة أوقات صلاتك. حاول مجددًا بعد قليل.",
      "remindersEmpty": "لا توجد قوائم في التذكيرات.",
      "openSettings": "فتح الإعدادات",
      "appleStopCta": "إيقاف الاستخدام"
    },
    "locked": {
      "body": "شاهد اجتماعاتك داخل فترات صلاتك، وأبقِ Google Tasks متزامنًا مع Rhemn.",
      "googleName": "تقويم Google ومهامه"
    },
    "device": {
      "phone": "iPhone",
      "pad": "iPad",
      "mac": "Mac",
      "fallback": "الجهاز"
    },
    "tasks": {
      "syncedWith_aria": "{{list}}، متزامنة مع {{provider}}",
      "unlinkConfirm": "إزالة «{{name}}» من Rhemn؟ ستبقى في {{provider}}.",
      "remove": "إزالة",
      "offline": "غير متصل · ستتم مزامنة التغييرات مع {{provider}} عند عودة الاتصال.",
      "stillSyncing": "لا تزال المزامنة مع {{provider}} جارية…",
      "failed_zero": "{{count}} تغيير لم يصل إلى {{provider}}.",
      "failed_one": "{{count}} تغيير لم يصل إلى {{provider}}.",
      "failed_two": "{{count}} تغيير لم يصل إلى {{provider}}.",
      "failed_few": "{{count}} تغييرات لم تصل إلى {{provider}}.",
      "failed_many": "{{count}} تغييرًا لم يصل إلى {{provider}}.",
      "failed_other": "{{count}} تغيير لم يصل إلى {{provider}}.",
      "retry": "إعادة المحاولة",
      "needsReconnect": "{{provider}} يحتاج منك إعادة الاتصال.",
      "paused": "المزامنة متوقفة · انتهى اشتراك Rhemn Pro.",
      "upgrade": "ترقية",
      "notSynced": "غير متزامن",
      "notSynced_aria": "غير متزامن مع {{provider}}. أعد المحاولة.",
      "remindersOff": "تعذّر على Rhemn الوصول إلى التذكيرات. أعد تفعيلها من الإعدادات.",
      "dueToday": "اليوم",
      "dueTomorrow": "غدًا",
      "googleTasks": "Google Tasks"
    },
    "today": {
      "allDay": "طوال اليوم",
      "more": "+{{count}}",
      "more_aria": "عرض {{count}} من أحداث اليوم الكامل الإضافية",
      "less_aria": "عرض أحداث أقل لليوم الكامل",
      "events_aria": "الأحداث",
      "event_aria": "من {{start}} إلى {{end}}، {{title}}",
      "allDayEvent_aria": "طوال اليوم، {{title}}",
      "untitled": "مشغول",
      "now": "الآن · حتى {{end}}",
      "until": "حتى {{end}}",
      "into": "· حتى وقت {{prayer}}",
      "loadError": "تعذّر تحميل تقويمك.",
      "needsReconnect": "يحتاج تقويم Google منك إعادة الاتصال.",
      "scope": "لا يستطيع Rhemn رؤية تقويم Google. أعد الاتصال وحدّد التقويم للسماح بذلك.",
      "appleOff": "لا يستطيع Rhemn رؤية تقويمك. أعد تفعيله من الإعدادات."
    },
    "plan": {
      "mostlyMeetings": "اجتماعات في الغالب · {{duration}} متاحة",
      "noFreeTime": "لا وقت متاح",
      "aroundMeetings_zero": "خُطِّط حول {{count}} اجتماع.",
      "aroundMeetings_one": "خُطِّط حول {{count}} اجتماع.",
      "aroundMeetings_two": "خُطِّط حول {{count}} اجتماعَين.",
      "aroundMeetings_few": "خُطِّط حول {{count}} اجتماعات.",
      "aroundMeetings_many": "خُطِّط حول {{count}} اجتماعًا.",
      "aroundMeetings_other": "خُطِّط حول {{count}} اجتماع.",
      "settledBusy": "كل شيء يتّسع بالفعل حول اجتماعاتك."
    },
    "meeting": {
      "group_aria": "اجتماع يبدأ",
      "now": "الآن",
      "takeNotes": "دوّن ملاحظات",
      "takeNotes_aria": "دوّن ملاحظات لـ {{title}}",
      "dismiss_aria": "تجاهل",
      "announce": "يبدأ {{title}} {{when}}.",
      "announceNow": "يبدأ {{title}} الآن.",
      "yourMeeting": "اجتماعك"
    },
    "apple": {
      "primer": {
        "title": "اعرض تقويمك بجانب صلواتك",
        "body": "يقرأ Rhemn الأحداث والتذكيرات على هذا {{device}} ليضعها في يومك. تبقى على جهازك. لا تستخدم ميزة «خطّط يومي» إلا الأوقات التي تكون فيها مشغولًا.",
        "cta": "متابعة",
        "skip": "ليس الآن",
        "footnote": "سيطلب {{device}} الإذن مرتين، مرة للتقويم ومرة للتذكيرات. يمكنك تغيير أيٍّ منهما من الإعدادات."
      }
    }
  }
}
